module.exports = __webpack_public_path__ + "static/pic25-b26ffb42eac7845aaae138e48a4ee8c0.png";